// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'

// Plugins
import utils from './imports' // Todos os imports

// App Principal
import App from './main.vue'

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router: utils.router,
  store: utils.store,
  components: { App },
  template: '<app/>'
})



// WEBPACK FOOTER //
// ./src/main.js